import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';

export default function TimedHomeNudgeStack({ children }) {
  const [visibilityByIndex, setVisibilityByIndex] = useState({});
  const childCount = React.Children.count(children);
  const reportedVisibleIndices = useMemo(
    () => Array.from(
      { length: childCount },
      (_, index) => index,
    ).filter((index) => visibilityByIndex[index] === true),
    [childCount, visibilityByIndex],
  );
  const visibilityReady = useMemo(
    () => Array.from(
      { length: childCount },
      (_, index) => Object.prototype.hasOwnProperty.call(visibilityByIndex, index),
    ).every(Boolean),
    [childCount, visibilityByIndex],
  );

  const handleVisibilityChange = useCallback((index, visible) => {
    setVisibilityByIndex((current) => {
      const nextVisible = visible === true;
      if (current[index] === nextVisible) return current;
      return { ...current, [index]: nextVisible };
    });
  }, []);

  const persistentChildren = React.Children.map(children, (child, index) => {
    return React.isValidElement(child)
      ? React.cloneElement(child, {
          homeNudgeIndex: index,
          homeNudgePhase: 'visible',
          homeNudgeExitDuration: 0,
          onHomeNudgeVisibilityChange: handleVisibilityChange,
        })
      : child;
  });
  const hasVisibleNudge = reportedVisibleIndices.length > 0;
  const hideEmptyStack = visibilityReady && !hasVisibleNudge;

  return (
    <div
      className="player-home-nudge-presence"
      data-phase="visible"
      data-testid="player-home-nudge-presence"
      hidden={hideEmptyStack}
    >
      <div
        className="player-home-nudge-stack max-w-6xl mx-auto w-full px-3 sm:px-4"
      >
        {persistentChildren}
      </div>
    </div>
  );
}
